export default __webpack_public_path__ + "locales/pl/ChangeUserTypeDialog.json?hash=c6e5ebccbbb0a3d3594565a90faeca29";